import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import OktaSignInWidget from '../security/OktaSignInWidget';
import { withOktaAuth } from '@okta/okta-react';
import AccessDeniedAlert from '../security/AccessDeniedAlert';
import {
  rememberLoginAttempt,
  getAccessDenied,
  clearAccessDenied,
} from '../security/loginAccessDenied';

import { USER_TYPES } from '../constants/ApplicationConstants';
import {
  DASHBOARD,
  SA_DASHBOARD,
  SR_DASHBOARD,
  ADMIN_BULLETIN,
} from '../constants/RouteConstants';
import { getUserTypeFromUrl } from '../utilities/UtilityFunctions';
import { ANALYTICS_EVENTS, trackEvent } from '../utilities/analytics';
import './login.less';
import { getEnvironmentValue, OKTA_DOMAIN } from '../../envConfig';
import CookieConsent from '../common/CookieConsent/CookieConsent';

export class Login extends Component {
  constructor(props) {
    super(props);
    this.onSuccess = this.onSuccess.bind(this);
    this.onError = this.onError.bind(this);
    this.setUrlParamsInStorage = this.setUrlParamsInStorage.bind(this);
    this.state = {
      authenticated: this.props.authState.isAuthenticated,
      accessDenied: getAccessDenied(),
    };
  }
  async checkAuthentication() {
    const authenticated = this.props.authState.isAuthenticated;
    if (authenticated) {
      clearAccessDenied();
    }
    if (authenticated !== this.state.authenticated) {
      this.setState({ authenticated });
    }
  }

  componentDidMount() {
    this.checkAuthentication();
    if (!this.props.authState.isAuthenticated) {
      trackEvent(ANALYTICS_EVENTS.LOGIN_STARTED, {
        user_type: getUserTypeFromUrl(),
      });
    }
  }

  componentDidUpdate() {
    this.checkAuthentication();
  }

  async onSuccess(res) {
    if (res.status === 'SUCCESS') {
      trackEvent(ANALYTICS_EVENTS.LOGIN_SUCCESS, {
        user_type: getUserTypeFromUrl(),
      });
      // The Okta callback does not say who signed in, keep it in case it fails.
      rememberLoginAttempt(res.user?.profile?.login);
      return this.props.oktaAuth.signInWithRedirect({
        sessionToken: res.session.token,
      });
    }
  }

  onError(err) {
    trackEvent(ANALYTICS_EVENTS.LOGIN_FAILED, {
      user_type: getUserTypeFromUrl(),
      error_message: err && err.message,
    });
  }

  setUrlParamsInStorage() {
    const urlParams = new URLSearchParams(window.location.search);
    const seedAdvisorID = urlParams.get('sa');
    seedAdvisorID &&
      window.localStorage.setItem('seed-advisor-id', seedAdvisorID);
    const zdPartnershipUuid = urlParams.get('zd');
    zdPartnershipUuid &&
      window.localStorage.setItem('zd-partnership-uuid', zdPartnershipUuid);
  }

  render() {
    if (this.state.authenticated === null) return null;
    const userType = getUserTypeFromUrl();
    let redirectUrl;

    // Store the intended user type for post-authentication redirect
    if (!this.state.authenticated) {
      sessionStorage.setItem('intendedUserType', userType);
    }

    switch (userType) {
      case USER_TYPES.GROWER:
        redirectUrl = DASHBOARD;
        this.setUrlParamsInStorage();
        break;
      case USER_TYPES.SEED_ADVISOR:
        redirectUrl = SA_DASHBOARD;
        break;
      case USER_TYPES.SALES_REPRESENTATIVE:
        redirectUrl = SR_DASHBOARD;
        break;
      case USER_TYPES.ADMIN:
        redirectUrl = ADMIN_BULLETIN;
        break;
      default:
        redirectUrl = DASHBOARD;
    }
    const { accessDenied } = this.state;
    return this.state.authenticated ? (
      <Redirect to={{ pathname: redirectUrl }} />
    ) : (
      <div>
        {accessDenied && <AccessDeniedAlert {...accessDenied} />}
        <OktaSignInWidget
          baseUrl={`${getEnvironmentValue(OKTA_DOMAIN)}`}
          onSuccess={this.onSuccess}
          onError={this.onError}
          oktaAuth={this.props.oktaAuth}
        />
        <CookieConsent />
      </div>
    );
  }
}

export default withOktaAuth(Login);
